import {QuestionMarkIcon} from '@esgi/ui-kit/icons';
import {OnHoverTooltip} from '@esgi/ui-kit/tooltip';
import {join} from '@esgi/ui-kit/utils';
import styles from './modal.module.less';

interface Props {
	url: string;
	title?: string;
	className?: string;
	onClick?: () => void;
}

export const HelpLink = (props: Props) => (
	<OnHoverTooltip message={props.title || 'Help'}>
		<a
			className={join(styles.helpIcon, props.className && props.className)}
			href={props.url}
			target='_blank'
			rel='noreferrer'
			onClick={() => props.onClick && props.onClick()}
		>
			<QuestionMarkIcon/>
		</a>
	</OnHoverTooltip>
);
